import Vue from 'vue'
import _ from 'lodash'
import {
  MODULE_TYPE_GARDEROB_L_RIGHT,
  MODULE_TYPE_GARDEROB_U
} from '../../resource/ModuleTypes'

export const state = {
  doorSwipeSide: 'prev',
  doorsPosition: {
    left: [],
    left_corner: [],
    middle: [],
    right_corner: [],
    right: []
  }
}

export const getters = {
  getHandPosition: (state, getters, rootState, rootGetters) => {
    let modules = rootGetters['modules/moduleCollectionChoose']

    let left = MODULE_TYPE_GARDEROB_L_RIGHT === rootState.moduleCurrent.moduleType ? 'middle' : 'left'
    let middle = MODULE_TYPE_GARDEROB_L_RIGHT === rootState.moduleCurrent.moduleType ? 'right' : 'middle'

    return {
      left: helpFunctionToHandPosition(modules, 'left', getters.getModules, left).reverse(),
      right: helpFunctionToHandPosition(modules, 'right', getters.getModules),
      middle: helpFunctionToHandPosition(modules, 'middle', getters.getModules, middle)
    }
  },

  getColor: (state, getters) => {
    let color = ''

    for (const property in getters.getDoorCurrent) {
      if (!getters.getDoorCurrent[property].length) continue

      let uniqBy = _.uniqBy(getters.getDoorCurrent[property], 'color')

      if (uniqBy.length === 1) {
        if (color === '') {
          color = uniqBy[0].color
        } else {
          if (uniqBy[0].color !== color) {
            return {color: 'color', show: false}
          }
        }
      } else {
        return {color: 'color', show: false}
      }
    }

    return {color: color, show: true}
  },

  getCornerDoor: (state, getters, rootState) => {
    return {
      left: rootState.doors.doors.filter(doors => doors.corner === 'left'),
      right: rootState.doors.doors.filter(doors => doors.corner === 'left'),
      middle: rootState.doors.doors.filter(doors => doors.corner === 'middle'),
      left_corner: rootState.doors.doors.filter(doors => Boolean(doors.is_corner)),
      right_corner: rootState.doors.doors.filter(doors => Boolean(doors.is_corner))
    }
  },

  getDoorCollection: (state, getters, rootState, rootGetters) => {
    let modules = rootGetters['modules/moduleCollectionChoose']

    let middle = MODULE_TYPE_GARDEROB_L_RIGHT === rootState.moduleCurrent.moduleType ? 'left' : ''

    let right = MODULE_TYPE_GARDEROB_L_RIGHT === rootState.moduleCurrent.moduleType ||
    MODULE_TYPE_GARDEROB_U === rootState.moduleCurrent.moduleType ? 'middle' : ''

    return {
      left: helpFunctionToCollection(modules, getters.getCornerDoor, 'left', getters.getModules).reverse(),
      right: helpFunctionToCollection(modules, getters.getCornerDoor, 'right', getters.getModules, right),
      middle: helpFunctionToCollection(modules, getters.getCornerDoor, 'middle', getters.getModules, middle),
      left_corner: helpFunctionToCollection(modules, getters.getCornerDoor, 'left_corner', getters.getModules),
      right_corner: helpFunctionToCollection(modules, getters.getCornerDoor, 'right_corner', getters.getModules)
    }
  },

  getModules: (state, getters, rootState, rootGetters) => (id) => {
    return rootGetters['modules/getModuleById'](id)
  },

  getDoorCurrent: (state, getters) => {
    let doorsChoose = getters.getDoorCollection

    if (!doorsChoose) return []

    return {
      left: helpCurrentFunction(doorsChoose, state, 'left'),
      left_corner: helpCurrentFunction(doorsChoose, state, 'left_corner'),
      middle: helpCurrentFunction(doorsChoose, state, 'middle'),
      right_corner: helpCurrentFunction(doorsChoose, state, 'right_corner'),
      right: helpCurrentFunction(doorsChoose, state, 'right')
    }
  }
}

export const mutations = {
  /**
   * Set door position
   *
   * @param state
   * @param payload
   * @constructor
   */
  SET_DOOR_POSITION (state, payload) {
    Vue.set(state.doorsPosition[payload.type], [payload.index], payload.position)
  },

  SET_DOOR_SWIPE_SIDE (state, payload) {
    state.doorSwipeSide = payload
  },

  CLEAR_DOOR_CURRENT (state) {
    state.doorSwipeSide = 'prev'

    state.doorsPosition = {
      left: [],
      left_corner: [],
      middle: [],
      right_corner: [],
      right: []
    }
  }
}

export const actions = {}

function helpFunctionToHandPosition (modules, key, getModules, fakeKey = '') {
  let data = []

  if (fakeKey === '') fakeKey = key

  if (!modules || (Array.isArray(modules[fakeKey]) && !modules[fakeKey].length)) return []

  modules[fakeKey].data.forEach((module, index) => {
    if (getModules(module[0].module_id).width === 100) {
      data.push(key === 'right' || key === 'middle' ? 'R' : 'L')

      data.push(key === 'right' || key === 'middle' ? 'L' : 'R')
    } else {
      data.push('L')
    }
  })

  return data
}

function helpFunctionToCollection (modules, doors, key, getModules, fakeKey = '') {
  let data = []

  if (!doors[key].length || !modules || (Array.isArray(modules[key]) && !modules[key].length)) return []

  let fakeIndex = 0

  let keyBecauseSewerPig = fakeKey === '' ? key : fakeKey

  let width = 0

  modules[key].data.forEach((module, index) => {
    width = getModules(module[0].module_id).width

    if (key === 'left_corner' || key === 'right_corner') {
      data[index + fakeIndex] = sortByColorDoor(doors[keyBecauseSewerPig])

      if (width === 100) {
        fakeIndex += 1

        data[index + fakeIndex] = sortByColorDoor(doors[keyBecauseSewerPig])
      }
    } else {
      data[index + fakeIndex] = sortByColorDoor(doors[keyBecauseSewerPig].filter(door => door.position === ((index + fakeIndex) + 1)))

      if (width === 100) {
        fakeIndex += 1

        data[index + fakeIndex] = sortByColorDoor(doors[keyBecauseSewerPig].filter(door => door.position === ((index + fakeIndex) + 1)))
      }
    }
  })

  return data
}

function sortByColorDoor (doors) {
  let newData = []

  newData.push(doors.find(door => door.color === 'Lustro'))
  newData.push(doors.find(door => door.color === 'Biały'))
  newData.push(doors.find(door => door.color === 'Biały połysk'))
  newData.push(doors.find(door => door.color === 'Dąb szary'))
  newData.push(doors.find(door => door.color === 'empty'))

  return newData
}

function helpCurrentFunction (modulesChoose, state, key) {
  if (Array.isArray(modulesChoose[key]) && !modulesChoose[key].length) return []

  return modulesChoose[key].map((item, index) => {
    if (!state.doorsPosition[key][index]) return item[0]
    return item[state.doorsPosition[key][index]]
  })
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/doorGarderobyCurrent.js